export default {
  site: {
    domain: 'Global',
    region: 'Global',
    subregion: 'Global',
    country: 'Global',
    entity: 'HSBC Bank Plc',
    brand: 'HSBC',
  },
  page: {
    language: 'en',
    channel: 'web',
    system: 'hsbcnet',
    category: 'online banking',
    businessLine: 'GBM',
    customerGroup: 'Business',
  },
};
